import type { IInitialEvent } from 'shared/lib/sendGAEvents';

import { sendStepsAnalyticsEvents } from 'entities/creditForm';

import { AdditionalInfoTexts } from 'features/UpdateAdditionalInfo';
import { ContactsInfoTexts } from 'features/UpdateContactsInfo';
import { CreditPurposeInfoTexts } from 'features/UpdateCreditPurposeInfo';
import { PassportInfoTexts } from 'features/UpdatePassportInfo';
import { WorkplaceInfoTexts } from 'features/UpdateWorkplaceInfo';

export const validateSuccessHandlerThunk =
  (analyticsOverrides?: Partial<Pick<IInitialEvent, 'event' | 'eventCategory'>>): ThunkResult<void> =>
  async (dispatch) => {
    dispatch(
      sendStepsAnalyticsEvents(
        Array.from({ length: 5 }, (_, i) => i),
        {
          ...CreditPurposeInfoTexts,
          ...ContactsInfoTexts,
          ...PassportInfoTexts,
          ...WorkplaceInfoTexts,
          ...AdditionalInfoTexts,
        },
        'auto',
        analyticsOverrides,
      ),
    );
  };
